if (!customElements.get('back-to-overview')) {
  class BackToOverview extends HTMLElement {
    constructor() {
      super();

      this.backToOverviewButton = document.getElementById('back-to-overview');
      this.fallbackUrl = this.getAttribute('data-fallback-url');

      this.backToOverviewButton.addEventListener('click', function (event) {
        event.preventDefault();

        let previousUrl;
        if (document.referrer) {
          previousUrl = new URL(document.referrer);
        }

        const currentUrl = new URL(window.location.href);

        if (typeof previousUrl !== 'undefined' && previousUrl.origin === currentUrl.origin) {
          window.history.back();
        } else {
          window.location.href = currentUrl.origin;
        }
      });
    }
  }

  window.BackToOverview = BackToOverview;
  customElements.define('back-to-overview', BackToOverview);
}
